export const GIFT_REVIEW_PAGE_STATIC_KEY = 'giftReviewPage'

export default GIFT_REVIEW_PAGE_STATIC_KEY
